export default "__VITE_ASSET__DWK6BFtg__"